import React, { useEffect, useState, useRef } from 'react';
import axios from "axios";
import { useSearchParams, Link } from "react-router-dom";
import { useAuth } from '../../../../../context/AuthContext';
import { API_BASE_URL } from "../../../../../Helpers/apiConfig";

export const Odemeokey = () => {
    const [searchParams] = useSearchParams();
    const { user, refreshUser } = useAuth();
    const [status, setStatus] = useState("loading"); // loading | approved | pending | error
    const [msg, setMsg] = useState("");
    const attemptsRef = useRef(0);

    const merchantOid = searchParams.get("merchant_oid");

    useEffect(() => {
        if (!merchantOid) {
            setStatus("error");
            setMsg("Sipariş bilgisi bulunamadı.");
            return;
        }

        let cancelled = false;

        const checkStatus = async () => {
            try {
                const headerss = {
                    accept: "*/*",
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + user.token
                };

                const res = await axios.get(API_BASE_URL + "/Paytr/CheckStatus", {
                    params: { merchantOid },
                    headers: headerss
                });

                if (cancelled) return;

                const paymentStatus = res.data?.status;

                if (paymentStatus === "approved") {
                    setStatus("approved");
                    await refreshUser();
                    return;
                }

                if (paymentStatus === "rejected") {
                    setStatus("error");
                    setMsg("Ödemeniz reddedildi.");
                    return;
                }

                attemptsRef.current += 1;
                if (attemptsRef.current >= 15) {
                    setStatus("pending");
                    return;
                }

                setTimeout(checkStatus, 2000);
            } catch (err) {
                if (!cancelled) {
                    setStatus("pending");
                }
            }
        };

        checkStatus();

        return () => { cancelled = true; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [merchantOid]);

    return (
        <div className="container text-center my-5">
            {status === "loading" && (
                <>
                    <div className="spinner-border text-primary mb-3" role="status">
                        <span className="visually-hidden">Yükleniyor...</span>
                    </div>
                    <h4>Ödemeniz onaylanıyor, lütfen bekleyin...</h4>
                </>
            )}

            {status === "approved" && (
                <>
                    <h2 className="text-success mb-3">Ödemeniz Başarılı!</h2>
                    <p>Paketiniz hesabınıza tanımlandı.</p>
                    <Link to="/user/course" className="btn btn-primary mt-3">Kurslarıma Git</Link>
                </>
            )}

            {status === "pending" && (
                <>
                    <h2 className="text-warning mb-3">Ödemeniz Alındı</h2>
                    <p>Ödemeniz işleniyor, paketiniz birazdan hesabınıza tanımlanacaktır. Bu sayfayı kapatabilirsiniz.</p>
                    {merchantOid && (
                        <p className="text-muted small">Sipariş numarası: <b>{merchantOid}</b></p>
                    )}
                    <Link to="/profile" className="btn btn-secondary mt-3">Profile Dön</Link>
                </>
            )}

            {status === "error" && (
                <>
                    <h2 className="text-danger mb-3">Bir Sorun Oluştu</h2>
                    <p>{msg}</p>
                    {merchantOid && (
                        <p className="text-muted small">
                            Ödemeniz alınmış olabilir. Destek talebi oluştururken bu sipariş numarasını belirtin: <b>{merchantOid}</b>
                        </p>
                    )}
                    <Link to="/profile" className="btn btn-secondary mt-3">Profile Dön</Link>
                </>
            )}
        </div>
    );
};

export default Odemeokey;
